export const WEEKDAY_NAMES = [
  "lundi",
  "mardi",
  "mercredi",
  "jeudi",
  "vendredi",
  "samedi",
  "dimanche",
];

export const DEFAULT_STAGE_DAYS = WEEKDAY_NAMES.slice(0, 5);

const WEEKDAY_SET = new Set(WEEKDAY_NAMES);

const SHORT = {
  lundi: "lun",
  mardi: "mar",
  mercredi: "mer",
  jeudi: "jeu",
  vendredi: "ven",
  samedi: "sam",
  dimanche: "dim",
};

export function normalizeDaysOfWeek(value) {
  const raw = Array.isArray(value)
    ? value
    : typeof value === "string" && value.trim()
      ? [value]
      : value && typeof value === "object"
        ? value.days_of_week || value.weekdays || value.active_days || value.day_of_week || []
        : [];
  const list = Array.isArray(raw) ? raw : raw ? [raw] : [];
  const seen = new Set();
  const days = [];
  for (const item of list) {
    const day = String(item || "").trim().toLowerCase();
    if (!WEEKDAY_SET.has(day) || seen.has(day)) continue;
    seen.add(day);
    days.push(day);
  }
  days.sort((a, b) => WEEKDAY_NAMES.indexOf(a) - WEEKDAY_NAMES.indexOf(b));
  return days;
}

export function formatDaysLabel(value) {
  const days = normalizeDaysOfWeek(value);
  if (!days.length) return "";
  if (days.length === 1) return SHORT[days[0]];
  const indexes = days.map((d) => WEEKDAY_NAMES.indexOf(d));
  const consecutive = indexes.every((idx, i) => i === 0 || idx === indexes[i - 1] + 1);
  if (consecutive) return `${SHORT[days[0]]}–${SHORT[days[days.length - 1]]}`;
  return days.map((d) => SHORT[d]).join(", ");
}

/** Libellé lisible : « lundi au vendredi » ou « lundi, mardi et jeudi ». */
export function formatDaysLabelLong(value) {
  const days = normalizeDaysOfWeek(value);
  if (!days.length) return "";
  if (days.length === 1) return days[0];
  const indexes = days.map((d) => WEEKDAY_NAMES.indexOf(d));
  const consecutive = indexes.every((idx, i) => i === 0 || idx === indexes[i - 1] + 1);
  if (consecutive) return `${days[0]} au ${days[days.length - 1]}`;
  if (days.length === 2) return `${days[0]} et ${days[1]}`;
  return `${days.slice(0, -1).join(", ")} et ${days[days.length - 1]}`;
}

export function firstWeekday(value) {
  return normalizeDaysOfWeek(value)[0] || "";
}

export function slotDaysLabel(slot) {
  if (!slot) return "";
  const days = normalizeDaysOfWeek(slot.days_of_week || slot.day_of_week);
  if (days.length) return formatDaysLabelLong(days);
  if (slot.days_label) return slot.days_label;
  return slot.day_of_week || "";
}
